import type { IPedidoGerenciarListItem, StatusPedido } from "interfaces/loja";

export function labelStatus(status: string): string {
  const map: Record<string, string> = {
    AGUARDANDO_PAGAMENTO: "Aguardando pagamento",
    PAGO: "Pago",
    PROCESSANDO: "Processando",
    EM_PROCESSAMENTO: "Em processamento",
    ENVIADO: "Enviado",
    ENTREGUE: "Entregue",
    CANCELADO: "Cancelado",
    DEVOLUCAO_SOLICITADA: "Devolução solicitada",
    DEVOLVIDO: "Devolvido",
  };
  return map[status] ?? status;
}

export function chipColorStatus(
  status: StatusPedido
): "default" | "primary" | "success" | "warning" | "error" | "info" {
  if (status === "ENTREGUE" || status === "PAGO") return "success";
  if (
    status === "ENVIADO" ||
    status === "PROCESSANDO" ||
    status === "EM_PROCESSAMENTO"
  )
    return "info";
  if (status === "AGUARDANDO_PAGAMENTO") return "warning";
  if (status === "DEVOLUCAO_SOLICITADA") return "warning";
  if (status === "CANCELADO" || status === "DEVOLVIDO") return "error";
  return "default";
}

export function totalItensPedido(row: IPedidoGerenciarListItem): number {
  return (row.itens ?? []).reduce(
    (acc, it) => acc + Number(it.quantidade ?? 0),
    0
  );
}

export function temRastreio(row: IPedidoGerenciarListItem): boolean {
  if (row.codigoRastreio && String(row.codigoRastreio).trim()) return true;
  return Boolean(
    row.envios?.some((e) => e.rastreio && String(e.rastreio).trim())
  );
}
